import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackRouteView } from '../utils/telemetry';

/**
 * Logs `ROUTE_VIEW` events whenever the router location changes.
 * Mount this once under the Router so it covers both marketing + `/app/*` areas.
 */
export const TelemetryListener: React.FC = () => {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;

    trackRouteView({
      path,
      pathname: location.pathname,
      from: prevPathRef.current,
    });

    prevPathRef.current = path;
  }, [location.pathname, location.search, location.hash]);

  return null;
};


